module.exports = __webpack_public_path__ + "img/menu-hair-12.7afbca9d.webp";